import LlaoL from "./logo.png"
import LlaoR from "./logo r.png"
import prod from "./productos.png"
import AEI from "./AEband gris.png"

export const LlaoLogoL = LlaoL;
export const LlaoLogoR = LlaoR;
export const prodImg = prod;
export const AEInfo = AEI;